'use client';

import { c as _c } from "react/compiler-runtime";
import SliderHand from '@components/slider-hand/SliderHand';
import HorizontalScrollInfraInfra from '@components/slider-Infrastructure/HorizontalScrollInfraInfra';
import HorizontalScrollInfraInfraMob from '@components/slider-Infrastructure/HorizontalScrollInfraInfraMob';
import { ScrollTrigger } from '@lib/tools/gsap-init';
import { useViewport } from '@lib/tools/hooks/useViewport';
import { useEffect, useRef, useState } from 'react';
import style from './SixthScreenInfra.module.scss';
function SixthScreenInfra() {
  const $ = _c(22);
  const [st18, setSt18] = useState(null);
  const [toggle, setToggle] = useState(false);
  const {
    isMobile,
    isTablet,
    isPortrait,
    isLandscape,
    userAgent
  } = useViewport();
  const svgRef = useRef(null);
  let t0;
  if ($[0] !== isMobile || $[1] !== toggle) {
    t0 = () => {
      let timerId;
      if (!toggle) {
        const element = svgRef.current;
        timerId = setTimeout(() => {
          setSt18(ScrollTrigger.create({
            trigger: element,
            id: "fall",
            start: "top center",
            scroller: !isMobile ? "#smooth-wrapper" : "body",
            scrub: true,
            pin: false,
            onToggle: () => {
              setTimeout(() => {
                setToggle(_temp);
              }, 500);
            }
          }));
        }, 1000);
      }
      return () => {
        if (timerId) {
          clearTimeout(timerId);
        }
      };
    };
    $[0] = isMobile;
    $[1] = toggle;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== isMobile) {
    t1 = [svgRef, isMobile];
    $[3] = isMobile;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  useEffect(t0, t1);
  let t2;
  if ($[5] !== st18) {
    t2 = () => () => {
      if (st18) {
        st18.kill();
      }
      setSt18(null);
      ScrollTrigger.getById("fall")?.kill();
    };
    $[5] = st18;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [];
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  useEffect(t2, t3);
  const isAdaptive = isMobile || isTablet;
  const isAdaptivePortrait = isAdaptive && isPortrait;
  const isAdaptiveLandscape = isAdaptive && isLandscape;
  const hiddenSliderHand = isAdaptivePortrait || isAdaptiveLandscape && userAgent === "none";
  let t4;
  if ($[8] !== isMobile) {
    t4 = !isMobile && <div className={style.fourthScreenWrapper}><div className={style.fourthScreenTextBox}><div data-scroll={true} data-scroll-speed="0.5" className={style.fourthScreenTitle}>Ведите дневник <br /> впечатлений</div><div data-scroll={true} data-scroll-speed="0.5" className={style.fourthScreenDescription}>Моментс живописно рисует свою картину мира посреди городской жизни. Неповторимая атмосфера экоквартала создаёт все условия для погружения в личный микрокосмос.{" "}</div></div></div>;
    $[8] = isMobile;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const t5 = !hiddenSliderHand;
  let t6;
  if ($[10] !== t5) {
    t6 = <SliderHand orientation="right" hidden={t5} />;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== isMobile || $[13] !== isTablet) {
    t7 = !isTablet && <HorizontalScrollInfraInfra isMobile={isMobile} />;
    $[12] = isMobile;
    $[13] = isTablet;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== isTablet) {
    t8 = isTablet && <HorizontalScrollInfraInfraMob />;
    $[15] = isTablet;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t4 || $[18] !== t6 || $[19] !== t7 || $[20] !== t8) {
    t9 = <><div ref={svgRef} data-scroll={true} className={style.fourthScreenContainer}>{t4}{t6}{t7}{t8}</div></>;
    $[17] = t4;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
}
function _temp() {
  return true;
}
export default SixthScreenInfra;